export const isUSMobileNumber = (phoneNumber, message) => {
  return /^[0-9]{10}$/.test(phoneNumber) ? true : message;
};
